import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import BooksFormErrorMessage from '../../../../components/books/model1/forms/BooksFormErrorMessage';

export enum ErrorType {
  Blank = 'blank',
  Failed = 'failed',
  Taken = 'taken',
  Invalid = 'invalid',
}

type InnerProps = InjectedIntlProps;

const BlankMessage: React.SFC<InnerProps> = ({ intl }) => (
  <BooksFormErrorMessage>
    {intl.formatMessage({
      id: `books.errors.createUser.blank`,
      defaultMessage: intl.formatMessage({ id: 'books.errors.blank' }),
    })}
  </BooksFormErrorMessage>
);

const TakenMessage: React.SFC<InnerProps> = ({ intl }) => (
  <BooksFormErrorMessage>
    {intl.formatMessage({
      id: `books.errors.createUser.taken`,
      defaultMessage: intl.formatMessage({ id: 'books.errors.taken' }),
    })}
  </BooksFormErrorMessage>
);

const InvalidMessage: React.SFC<InnerProps> = ({ intl }) => (
  <BooksFormErrorMessage>
    {intl.formatMessage({
      id: `books.errors.createUser.invalid`,
      defaultMessage: intl.formatMessage({
        id: 'books.errors.invalid',
      }),
    })}
  </BooksFormErrorMessage>
);

const ERROR_COMPONENTS: {
  // tslint:disable-next-line:no-any
  [error in ErrorType]: React.ComponentClass | undefined;
} = {
  [ErrorType.Blank]: injectIntl(BlankMessage),
  [ErrorType.Taken]: injectIntl(TakenMessage),
  [ErrorType.Invalid]: injectIntl(InvalidMessage),
  [ErrorType.Failed]: undefined,
};

interface Props {
  errors?: ErrorType[];
}

class InputBookingWaitingListErrorMessage extends React.Component<Props> {
  public render() {
    const { errors } = this.props;
    if (!errors) {
      return null;
    }
    if (errors.length === 0) {
      return null;
    }
    return errors.map((error, index) => {
      const Component = ERROR_COMPONENTS[error];
      if (!Component) {
        return null;
      }
      return <Component key={index} />;
    });
  }
}

export default InputBookingWaitingListErrorMessage;
